/* ECLO Collagène A4, mobile-only structure. Native product form untouched.
   Responsive DOM relocation only: headline price alongside existing reviews; studies as <details>.
   Desktop unmodified. Source study articles stay in the DOM, not cloned or duplicated. */
(function(){
  'use strict';
  if(window.ECLOCollageneA4) {window.ECLOCollageneA4.refresh();return;}
  var mq=window.matchMedia('(max-width:749px)');
  function getElements(){
    var marker=document.querySelector('[data-collagene-a4]');
    if(!marker)return null;
    var root=marker.closest('[data-ev11-a2-range="collagene"]')||document.querySelector('[data-ev11-a2-range="collagene"]');
    var science=document.querySelector('.eclo-science-v16');
    if(!root||!science)return null;
    return{root:root,science:science,review:root.querySelector('.eclo-v9-reviewline'),
      price:root.querySelector('.ev11-ab-top-price'),titleRow:root.querySelector('.ev11-ab-title-row')};
  }
  function articleData(article,idx){
    var visual=article.querySelector('.eclo-science-v16__protocol-visual');
    var period=visual&&visual.querySelector('strong')?.textContent.trim()||'';
    var title=article.querySelector('.eclo-science-v16__body h3')?.textContent.trim()||'';
    var protocol=article.querySelector('.eclo-science-v16__protocol');
    var metadata=protocol?Array.from(protocol.querySelectorAll('span')).slice(0,2).map(function(n){return n.textContent.trim()}).filter(Boolean).join(' · '):'';
    var badge=article.querySelector('.eclo-science-v16__badge')?.textContent.trim()||'';
    return{period:period,title:title,meta:metadata,badge:badge};
  }
  function el(tag,cls,txt){
    var n=document.createElement(tag);if(cls)n.className=cls;if(txt!=null)n.textContent=txt;return n;
  }
  function wrapStudies(science){
    if(science.classList.contains('a4-accordion-ready'))return;
    var studies=Array.from(science.querySelectorAll('.eclo-science-v16__studies > article.eclo-science-v16__study'));
    if(!studies.length)return;
    studies.forEach(function(article,idx){
      var d=el('details','eclo-a4-study');
      d.open=idx===0;
      var summary=el('summary');
      var content=el('span','eclo-a4-summary-content');
      var info=articleData(article,idx);
      content.appendChild(el('span','eclo-a4-summary-period',info.badge+' · '+info.period));
      content.appendChild(el('strong','eclo-a4-summary-title',info.title));
      if(info.meta)content.appendChild(el('span','eclo-a4-summary-meta',info.meta));
      summary.appendChild(content);
      var plus=el('span','eclo-a4-expand','+');plus.setAttribute('aria-hidden','true');
      summary.appendChild(plus);
      d.appendChild(summary);
      article.parentNode.insertBefore(d,article);
      d.appendChild(article);
    });
    science.classList.add('a4-accordion-ready');
    science.dataset.a4StudyCount=String(studies.length);
  }
  function unwrapStudies(science){
    if(!science.classList.contains('a4-accordion-ready'))return;
    science.querySelectorAll('.eclo-a4-study').forEach(function(d){
      var article=d.querySelector(':scope > article.eclo-science-v16__study');
      if(article)d.parentNode.insertBefore(article,d);
      d.remove();
    });
    science.classList.remove('a4-accordion-ready');
  }
  function refresh(){
    var e=getElements();if(!e)return;
    document.body.classList.add('eclo-collagene-a4');
    if(mq.matches){
      if(e.review&&e.price&&e.price.parentElement!==e.review)e.review.appendChild(e.price);
      wrapStudies(e.science);
      e.root.dataset.a4Mobile='true';
    }else{
      if(e.titleRow&&e.price&&e.price.parentElement!==e.titleRow)e.titleRow.appendChild(e.price);
      unwrapStudies(e.science);
      e.root.dataset.a4Mobile='false';
    }
    e.root.ecloA4Inspect=function(){
      return{mobile:mq.matches,innerWidth:innerWidth,scrollWidth:document.documentElement.scrollWidth,
        headline:e.root.querySelector('h1')?.textContent.trim()||'',
        price:e.price?.innerText.trim()||'',priceParent:e.price?.parentElement?.className||'',
        accordions:e.science.querySelectorAll('details.eclo-a4-study').length,
        openAccordions:e.science.querySelectorAll('details.eclo-a4-study[open]').length,
        studies:e.science.querySelectorAll('article.eclo-science-v16__study').length,
        overflow:document.documentElement.scrollWidth>innerWidth};
    };
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
  if(mq.addEventListener)mq.addEventListener('change',refresh);
  else if(mq.addListener)mq.addListener(refresh);
  document.addEventListener('shopify:section:load',refresh);
  window.ECLOCollageneA4={refresh:refresh};
})();
